var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('van-loading',{attrs:{"type":_vm.type,"color":_vm.color,"size":"24px"}},[_vm._v(_vm._s(_vm.children))]),_c('div',{staticClass:"loadingFont"},[_vm._v(_vm._s(_vm.accountFont))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }